import { RiUploadCloud2Line } from "react-icons/ri";
import BreadcrumbPurchase from "./purchaseComponents/BreadcrumbPurchase";
import { LuClipboardList } from "react-icons/lu";
import { GrLocation } from "react-icons/gr";
import { IoBriefcaseOutline, IoLockClosedOutline } from "react-icons/io5";
import { CiStar } from "react-icons/ci";
import { useState } from "react";
import { FaCheck, FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { Box, CircularProgress } from "@mui/material";
import { useFormik } from "formik";
import IdentityForm from "./amanahComponents/IdentityForm";
import SelfInformationForm from "./amanahComponents/SelfInformationForm";
import { useMutation, useQuery } from "@tanstack/react-query";
import {
  activateOlinAmanah,
  getFormArea,
  getFormSelection,
} from "../../../services/olinAmanah";
import AddressForm from "./amanahComponents/AddressForm";
import BusinessDetailForm from "./amanahComponents/BusinessDetailForm";
import PinForm from "./amanahComponents/PinForm";
import TnCForm from "./amanahComponents/TnCForm";
import LoadingBackdrop from "../../common/particles.jsx/LoadingBackdrop";
import { useNavigate } from "react-router-dom";
import ErrorPopup from "../../common/particles.jsx/ErrorPopup";

const stepperArr = [
  {
    id: 1,
    icon: <RiUploadCloud2Line className="w-full h-full" />,
    title: "Kartu Identitas",
    description: "Unggah Foto KTP dan swafoto memegang KTP",
  },
  {
    id: 2,
    icon: <LuClipboardList className="w-full h-full" />,
    title: "Data Pribadi",
    description: "Lengkapi informasi pribadi peminjam",
  },
  {
    id: 3,
    icon: <GrLocation className="w-full h-full" />,
    title: "Alamat Lengkap",
    description: "Lengkapi informasi alamat peminjam",
  },
  {
    id: 4,
    icon: <IoBriefcaseOutline className="w-full h-full" />,
    title: "Detail Usaha",
    description: "Lengkapi informasi usaha peminjam",
  },
  {
    id: 5,
    icon: <IoLockClosedOutline className="w-full h-full" />,
    title: "PIN",
    description: "Buat dan konfirmasi PIN",
  },
  {
    id: 6,
    icon: <CiStar className="w-full h-full" />,
    title: "Selesai",
    description: "Setujui syarat dan ketentuan, OLIN Amanah siap digunakan",
  },
];

const ActivateOlinAmanah = () => {
  const navigate = useNavigate();

  const [activeStep, setActiveStep] = useState(1);
  const [confirmPin, setConfirmPin] = useState("");
  const [isAgree, setIsAgree] = useState({ qard: false, ijaroh: false });
  const [isIjarohPage, setIsIjarohPage] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const isValidNext = () => {
    if (activeStep === 1) return formik.values.ktp && formik.values.selfie;
    if (activeStep === 2)
      return (
        formik.values.data.data_info.nik !== "" &&
        formik.values.data.data_info.nik.length === 16 &&
        formik.values.data.data_info.place_of_birth !== "" &&
        formik.values.data.data_info.gender_id !== "" &&
        formik.values.data.data_info.marital_status_id !== "" &&
        formik.values.data.data_info.religion_id !== "" &&
        formik.values.data.data_info.education_id !== "" &&
        formik.values.data.data_info.mother_name !== "" &&
        formik.values.data.account_info.name !== "" &&
        formik.values.data.account_info.email !== "" &&
        formik.values.data.account_info.phone_number !== ""
      );
    if (activeStep === 3)
      return (
        formik.values.data.identity_address.address !== "" &&
        formik.values.data.domicile_address.address !== "" &&
        formik.values.data.identity_address.rt !== "" &&
        formik.values.data.domicile_address.rt !== "" &&
        formik.values.data.identity_address.rw !== "" &&
        formik.values.data.domicile_address.rw !== "" &&
        formik.values.data.identity_address.province !== "" &&
        formik.values.data.domicile_address.province !== "" &&
        formik.values.data.identity_address.city !== "" &&
        formik.values.data.domicile_address.city !== "" &&
        formik.values.data.identity_address.district !== "" &&
        formik.values.data.domicile_address.district !== "" &&
        formik.values.data.identity_address.sub_district !== "" &&
        formik.values.data.domicile_address.sub_district !== "" &&
        formik.values.data.identity_address.postal_code !== "" &&
        formik.values.data.domicile_address.postal_code !== ""
      );
    if (activeStep === 4)
      return (
        formik.values.data.business_info.name !== "" &&
        formik.values.data.business_info.address !== "" &&
        formik.values.data.business_info.business_type_id !== "" &&
        formik.values.data.business_info.building_type_id !== "" &&
        formik.values.data.business_info.bank_id !== "" &&
        formik.values.data.business_info.industry_type_id !== "" &&
        formik.values.data.business_info.business_age_id !== "" &&
        formik.values.data.business_info.account_number !== "" &&
        formik.values.data.business_info.account_name !== "" &&
        formik.values.data.business_info.average_income !== 0 &&
        formik.values.data.business_info.average_profit_percentage !== 0
      );
    if (activeStep === 5)
      return (
        formik.values.data.pin !== 0 &&
        formik.values.data.pin.toString() === confirmPin
      );
    if (activeStep === 6)
      return (
        (isIjarohPage && isAgree.ijaroh && isAgree.qard) ||
        (!isIjarohPage && isAgree.qard)
      );
  };

  const handleActivate = () => {
    mutateActivate(formik.values);
  };

  const formik = useFormik({
    initialValues: {
      ktp: null,
      selfie: null,
      data: {
        business_info: {
          name: "",
          address: "",
          business_type_id: "",
          building_type_id: "",
          bank_id: "",
          industry_type_id: "",
          business_age_id: "",
          account_number: "",
          account_name: "",
          average_income: 0.0,
          average_profit_percentage: 0.0,
        },
        identity_address: {
          address: "",
          rt: "",
          rw: "",
          province: "",
          city: "",
          district: "",
          sub_district: "",
          postal_code: "",
        },
        domicile_address: {
          address: "",
          rt: "",
          rw: "",
          province: "",
          city: "",
          district: "",
          sub_district: "",
          postal_code: "",
        },
        data_info: {
          nik: "",
          place_of_birth: "",
          date_of_birth: "",
          gender_id: "",
          marital_status_id: "",
          religion_id: "",
          education_id: "",
          mother_name: "",
        },
        account_info: {
          name: "",
          email: "",
          phone_number: "",
        },
        pin: 0,
        product_id: "",
      },
    },
  });

  const {
    data: dataSelection,
    isFetching: isFetchingSelection,
    error,
  } = useQuery({
    queryKey: ["select-amanah"],
    queryFn: () => getFormSelection(),
    retry: 3,
    refetchOnWindowFocus: false,
  });

  const {
    mutate: mutateArea,
    isLoading: isLoadingArea,
    data: dataArea,
  } = useMutation({
    mutationFn: getFormArea,
  });

  const { mutate: mutateActivate, isLoading: isLoadingActivate } = useMutation({
    mutationFn: activateOlinAmanah,
    onSuccess: () => navigate(`/purchase/confirm-amanah`),
    onError: (err) =>
      setErrorMessage(err.message.id ? err.message.id : err.message),
  });

  return (
    <div className="text-[12px] text-[#2C3E5D]">
      <LoadingBackdrop isLoading={isLoadingActivate} />
      <div className="mt-[70px] lg:mt-0">
        <BreadcrumbPurchase />
        <p className="text-[24px] font-semibold mb-4">Aktivasi Olin Amanah</p>
      </div>
      <div className="mb-4 block md:flex gap-4 items-start">
        <div className="w-full md:basis-2/3 lg:basis-1/2 bg-white p-4 rounded-lg mb-4 md:mb-0">
          <div className="w-full hidden md:block">
            <p className="font-bold text-[16px] mb-4">Langkah Aktivasi</p>

            <div className="w-full">
              {stepperArr.map((item, i) => {
                return (
                  <div className="relative flex items-start gap-4 mb-4 w-full">
                    {i === stepperArr.length - 1 ? null : (
                      <div
                        className={`w-[5px] h-[calc(100%+50px)] absolute left-[22px] top-0 rounded-full ${
                          activeStep > item.id
                            ? "bg-[#4FB33C] text-white"
                            : "bg-[#DCDFE4]"
                        }`}
                      />
                    )}
                    <div
                      className={`rounded-full h-[50px] w-[50px] p-3 flex items-center justify-center shrink-0 z-10 ${
                        activeStep === item.id
                          ? "bg-[#071B82] text-white"
                          : activeStep > item.id
                          ? "bg-[#4FB33C] text-white"
                          : "bg-white text-[#8590A2] border-2"
                      }`}
                    >
                      {activeStep <= item.id ? item.icon : <FaCheck />}
                    </div>
                    <div
                      className={`w-full shrink overflow-hidden ${
                        activeStep === item.id ? "" : "text-[#8590A2]"
                      }`}
                    >
                      <p className="text-[14px]">{item.title}</p>
                      <p>{item.description}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="w-full block md:hidden flex items-center gap-4">
            <div>
              <Box sx={{ position: "relative", display: "inline-flex" }}>
                <CircularProgress
                  variant="determinate"
                  value={(activeStep / 6) * 100}
                  style={{ color: "#071B82" }}
                  size={80}
                />
                <Box
                  sx={{
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                    position: "absolute",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: 24,
                    fontWeight: "bold",
                  }}
                >
                  {activeStep}/6
                </Box>
              </Box>
            </div>
            <div className="flex items-start gap-2">
              <div className="w-full shrink">
                <p className="text-[14px] font-semibold">
                  {stepperArr.find((item) => item.id === activeStep)?.title}
                </p>
                <p>
                  {
                    stepperArr.find((item) => item.id === activeStep)
                      ?.description
                  }
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="w-full bg-white p-4 rounded-lg ">
          <p className="font-bold text-[16px] mb-4">
            {stepperArr.find((step) => step.id === activeStep)?.title}
          </p>

          <div className="mb-4">
            {/* {dataSelection && !isFetchingSelection  ? ( */}
            {true ? (
              activeStep === 1 ? (
                <IdentityForm formik={formik} />
              ) : activeStep === 2 ? (
                <SelfInformationForm
                  formik={formik}
                  dataSelection={dataSelection}
                />
              ) : activeStep === 3 ? (
                <AddressForm
                  formik={formik}
                  dataSelection={dataSelection}
                  dataArea={dataArea}
                  isLoadingArea={isLoadingArea}
                  mutateArea={mutateArea}
                />
              ) : activeStep === 4 ? (
                <BusinessDetailForm
                  formik={formik}
                  dataSelection={dataSelection}
                />
              ) : activeStep === 5 ? (
                <PinForm
                  formik={formik}
                  confirmPin={confirmPin}
                  setConfirmPin={setConfirmPin}
                />
              ) : activeStep === 6 ? (
                <TnCForm
                  isAgree={isAgree}
                  setIsAgree={setIsAgree}
                  isIjarohPage={isIjarohPage}
                />
              ) : null
            ) : isFetchingSelection ? (
              <div className="flex items-center justify-center">
                <CircularProgress size={20} />
              </div>
            ) : (
              <p className="text-center w-full text-red-500">
                {error
                  ? error.message.id
                    ? error.message.id
                    : error.message
                  : ""}
              </p>
            )}
          </div>

          <div
            className={`flex items-center ${
              activeStep === 1 ? "justify-end" : "justify-between"
            }`}
          >
            {activeStep === 1 ? null : (
              <button
                type="button"
                className={`flex items-center justify-center gap-2 text-[#6F955B] border-2 border-[#6F955B] bg-[#F1FAF0] hover:bg-gray-300 rounded-md w-fit py-2.5 px-4 text-[14px] disabled:bg-gray-300 disabled:border-none disabled:text-white`}
                disabled={activeStep === 1}
                onClick={() => {
                  setActiveStep(activeStep - 1);
                  setIsAgree({ qard: false, ijaroh: false });
                  setIsIjarohPage(false);
                }}
              >
                <FaChevronLeft />
                <p>Sebelumnya</p>
              </button>
            )}
            <button
              type="button"
              className={`flex items-center justify-center gap-2 text-white bg-[#94C679] hover:bg-gray-300 rounded-md w-fit py-2.5 px-4 text-[14px] disabled:bg-gray-300 `}
              disabled={!isValidNext()}
              onClick={() => {
                if (activeStep === 6 && isAgree.qard && !isAgree.ijaroh)
                  setIsIjarohPage(true);
                if (activeStep === 6 && isAgree.qard && isAgree.ijaroh)
                  handleActivate();
                if (activeStep < 6) setActiveStep(activeStep + 1);
              }}
            >
              <p>
                {activeStep === 6 && isIjarohPage ? "Kirim" : "Selanjutnya"}
              </p>
              <FaChevronRight />
            </button>
          </div>
        </div>
      </div>

      <ErrorPopup
        errorMessage={errorMessage}
        setErrorMessage={setErrorMessage}
      />
    </div>
  );
};

export default ActivateOlinAmanah;
